import React from "react";
import moment from "moment-jalaali";
import * as search from "../../../../SearchPage/_redux/searchRedux";
import { injectIntl } from "react-intl";
import { connect, shallowEqual, useDispatch } from "react-redux";
import { search_travel } from "../../../../SearchPage/_redux/searchCrud";
import { useHistory } from "react-router-dom";
import { useSelector } from "../../../../../utils/react-redux-hooks";
import SearchSectionSearchWidget from "../../../../Homepage/pages/widgets/components/SearchSectionSearchWidget";
import SearchSectionBody from "../../../../Homepage/pages/widgets/components/searchSectionBody";
// import PriceAndTimeFilter from "../../../../Homepage/pages/widgets/components/PriceAndTimeFilter";
import MobileNotificationAndHeader from "../../../../Homepage/pages/widgets/components/MobileNotificationAndHeader";
import { actions } from "../../../../ReservePage/_redux/reserveRedux";
import { Loop } from "@material-ui/icons";
import { Dialog, Button } from "@material-ui/core";

function UpdateReserve(props) {
  
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const history = useHistory();

  const dispatch = useDispatch();

  React.useEffect(() => {
    setTimeout(() => {
      handleOpen();
    }, 10);
  }, []);

  React.useEffect(() => {
    
    dispatch(actions.setLoadingStats(undefined));
    const seatCount = props.count;
    const count = Number(seatCount[0]) + Number(seatCount[1]);
    search_travel(props.source_id, props.dest_id, props.date, count)
      .then((data) => {
        props.loadTravels(data.data.data);
        props.setFilteredTravels(data.data.data);
        dispatch(actions.setMockTravels(data.data.data));
        if (data.data.data.length === 0) {
          dispatch(actions.setLoadingStats("0"));
        } else {
          dispatch(actions.setLoadingStats("1"));
        }
      })
      .catch(function (error) {
        props.serverErrorOccurred(error);
        dispatch(actions.setLoadingStats("-1"));
        dispatch(actions.setMockTravels([]));
      });
  }, []);

  let day2_string = "";
  if (props.date2 !== null)
    day2_string = moment(props.date2).format("dddd jD jMMMM");


  return (
    <div>
      {/* begin::Dashboard */}
      <Dialog
        open={open}
        onClose={handleClose}
        keepMounted
        className="p-10"
        PaperProps={{ style: { maxHeight: "unset" } }}
        disableBackdropClick
      >
        <div className="row container mx-auto p-4">
          <div className="col-12 d-flex justify-content-center">
            <Loop
              className="col-6"
              style={{
                fontSize: "10rem",
                color: "#6dd06d",
                transform: "rotate(90deg)",
              }}
            />
          </div>
          <div
            className="d-flex flex-column align-items-center justify-content-center col-12"
            style={{ gap: 10 }}
          >
            <h1 className="text-dark" style={{textAlign:"center"}}>
              {" "}
              <b>زمان رزرو اولیه شما به پایان رسید</b>
            </h1>
            <h6
              className="container mt-5 mb-3 d-flex justify-content-center"
              style={{ lineHeight: "30px", color: "#4c4b4b" }}
            >
              لطفا گزینه مورد نظرتان را انتخاب کنید. 
              </h6>
            <div className="row container">
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                <Button
                  className="w-100 h-100"
                  style={{
                    backgroundColor: "#6dd06d",
                    border: "0.5px solid white",
                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    handleClose();
                    dispatch(actions.setLoadingStats(undefined));
                    const seatCount = props.count;
                    const count = Number(seatCount[0]) + Number(seatCount[1]);
                    search_travel(props.source_id, props.dest_id, props.date, count)
                      .then((data) => {
                        // console.log("ooooooo",data.data.data);
                        // console.log("ttttt",data.data.data[id].travelId);
                        props.loadTravels(data.data.data);
                        props.setFilteredTravels(data.data.data);
                        // console.log("propsssssssssssss",props);
                        dispatch(actions.setMockTravels(data.data.data));
                        // history.push(
                        //   `/bus-ticket/${props.source_id}/${props.dest_id}?date=${props.date}&count=${props.count}`
                        //   // `/bus-ticket-reverse/${props.source_id}/${props.dest_id}/${props.date}/${props.travelId}/${props.count}`
                        // );
                        window.location.reload(false)

                        if (data.data.data.length === 0) {
                          console.log("0000");
                          dispatch(actions.setLoadingStats("0"));
                        } else {
                          console.log("11111");
                          dispatch(actions.setLoadingStats("1"));
                        }
                      })
                      .catch(function (error) {
                        props.serverErrorOccurred(error);
                        dispatch(actions.setLoadingStats("-1"));
                        dispatch(actions.setMockTravels([]));
                      });
                  }}
                >
                  <h6 className="mx-auto my-auto text-white">
                    جستجوی مجدد
                  </h6>
                </Button>
              </div>
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                <Button
                  className="w-100 h-100 bg-white"
                  style={{
                    border: "0.5px solid #6dd06d",

                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <h6 className="mx-auto my-auto " style={{ color: "#6dd06d" }}>
                    بازگشت به صفحه اصلی
                  </h6>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

    </div>
  );
}

export default injectIntl(connect(null, search.actions)(UpdateReserve));
